import { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { primaryBtn, secondaryBtn, BasicDiv } from "../styles";
import logo from "../img/logo.svg";
import magnify from "../img/magnify.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import MenuList from "./MenuList";
import SubMenu from "./SubMenu";
import { Cross as Hamburger } from "hamburger-react";
import { Link } from "react-router-dom";

import { v4 as uuidv4 } from "uuid";

function NavBar({ subMenuList, setSubMenuindex, dataMenu }) {
  const subMenuIndexHandler = () => {
    setSubMenuindex(dataMenu[0].subMenu);
  };

  const subMenuZero = () => {
    setSubMenuindex([]);
  };

  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <MainNav>
        <NavContainer>
          <Logo>
            <Link to="/">
              <img src={logo} alt="mazuma logo" />
            </Link>
          </Logo>
          <div className="hamburger">
            <Hamburger
              toggled={isOpen}
              toggle={setOpen}
              color={isOpen ? "#13324f" : "white"}
            />
          </div>

          {isOpen && (
            <div className="mobile-nav-container">
              <div className="invite-links">
                <Link to="/login">
                  <LoginButton>Login</LoginButton>
                </Link>

                <Link to="/signup">
                  <SignUpBtn>Sign Up</SignUpBtn>
                </Link>
              </div>

              <div className="menu-i">
                {dataMenu.map((e) => {
                  if (e.item !== null) {
                    return (
                      <MenuList
                        item={e.item}
                        key={e.id}
                        subMenu={e.subMenu}
                        setSubMenuindex={setSubMenuindex}
                      />
                    );
                  } else {
                    return <span key={e.id}></span>;
                  }
                })}
              </div>

              <div className="mini-icons">
                <div onMouseOver={subMenuIndexHandler}>
                  <select
                    id="province"
                    name="province"
                    className="province-select"
                  >
                    <option value="ontario">ON</option>
                    <option value="british-columbia">BC</option>
                    <option value="alberta">AB</option>
                    <option value="Quebec">QC</option>
                  </select>
                </div>

                <div onMouseOver={subMenuIndexHandler}>
                  <button className="lang-btn">
                    <FontAwesomeIcon icon={faGlobe} />
                  </button>
                </div>

                <div onMouseOver={subMenuIndexHandler}>
                  <button className="abm">
                    <FontAwesomeIcon icon={faMapMarkerAlt} /> ABM Locator
                  </button>
                </div>
              </div>
            </div>
          )}

          <Navigators>
            {dataMenu.map((e) => {
              if (e.item !== null) {
                return (
                  <MenuList
                    item={e.item}
                    key={e.id}
                    subMenu={e.subMenu}
                    setSubMenuindex={setSubMenuindex}
                  />
                );
              } else {
                return <div key={e.id}></div>;
              }
            })}
          </Navigators>
          <ButtonContainer onMouseOver={subMenuZero} onClick={subMenuZero}>
            <Link to="/login">
              <LoginButton>Login</LoginButton>
            </Link>

            <Link to="/signup">
              <SignUpBtn> Sign Up</SignUpBtn>
            </Link>
          </ButtonContainer>
        </NavContainer>
      </MainNav>
      <SecondNavContainer>
        <SecondNav>
          <Navigators>
            {subMenuList.map((e) => {
              return <SubMenu item={e} key={uuidv4()} />;
            })}
          </Navigators>

          <ExtraNav>
            <div>
              <select id="province" name="province" className="province-select">
                <option value="ontario">ON</option>
                <option value="british-columbia">BC</option>
                <option value="alberta">AB</option>
                <option value="Quebec">QC</option>
              </select>
            </div>

            <div>
              <button className="lang-btn">
                <FontAwesomeIcon icon={faGlobe} />
              </button>
            </div>

            <div>
              <button className="abm">
                <FontAwesomeIcon icon={faMapMarkerAlt} /> ABM Locator
              </button>
            </div>

            <motion.div className="search-div">
              <img src={magnify} alt="" />

              <input
                className="search-input"
                type="text"
                placeholder="Interest free loans"
              />
            </motion.div>
          </ExtraNav>
        </SecondNav>
      </SecondNavContainer>
    </div>
  );
}

export default NavBar;

const MainNav = styled(motion.nav)`
  position: fixed;
  top: 0;
  z-index: 20;
  background: #19456b;
  width: 100%;
  margin: auto;
`;

const NavContainer = styled(motion.div)`
  min-height: 4.5rem;
  margin: auto;
  display: flex;
  padding: 0rem 3rem;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  position: relative;

  @media (max-width: 1180px) {
    padding-right: 1rem;
    height: 100%;
  }

  .mobile-nav-container {
    display: none;
    position: absolute;
    background: #ffffff;
    top: 0;
    right: 0;
    z-index: 20;
    padding-bottom: 2rem;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.35);
    border-top-left-radius: 5rem;
    border-bottom-left-radius: 5rem;
    width: 11rem;

    .menu-i,
    .invite-links,
    .mini-icons {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;
      width: 100%;
      padding-right: 1rem;

      @media (max-width: 550px) {
        align-items: center;
        padding-right: 0rem;
      }
    }

    .menu-i {
      margin: 1rem 0rem;
    }

    .mini-icons {
      div {
        padding: 0.2rem 0rem;
      }

      .province-select,
      .lang-btn,
      .abm {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none; /* Remove default arrow */
        border: none;
        padding: 0rem 0.5rem;
        background: none;
        cursor: pointer;
        border-radius: 3rem;
        /* border: solid 2px #19456b; */
      }
    }

    .invite-links {
      border-top-left-radius: 5rem;
      background: #dfdfdf;
      padding-top: 5rem;
      padding-bottom: 2rem;

      @media (max-width: 550px) {
        border-radius: 0rem;
        padding-top: 2rem;
      }
    }

    @media (max-width: 1180px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    @media (max-width: 900px) {
    }

    @media (max-width: 750px) {
    }

    @media (max-width: 550px) {
      width: 100vw;
      border-radius: 0rem;
    }
  }

  .hamburger {
    display: none;
    z-index: 200;

    .hamburger-react {
      color: white;

      &:active {
        color: #19456b;
      }
    }

    @media (max-width: 1180px) {
      display: block;
      z-index: 200;
    }
  }

  @media (max-width: 800px) {
    padding: 0rem 1rem;
  }

  @media (min-width: 1600px) {
    width: 100rem;
  }
`;

const SecondNavContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  z-index: 19;
  margin-top: 4.5rem;
  min-height: 3rem;
  width: 100%;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
  background: #f8f1f1;
`;

const SecondNav = styled(motion.div)`
  display: flex;
  padding: 0rem 3rem;
  align-items: center;
  min-height: 3rem;
  margin: auto;
  justify-content: space-between;
  width: 100%;

  @media (min-width: 1600px) {
    width: 100rem;
  }
`;

const Logo = styled(motion.div)`
  color: white;
  display: flex;
  padding-right: 8rem;
  cursor: pointer;

  @media (max-width: 800px) {
    padding-right: 0rem;
  }

  @media (max-width: 800px) {
    img {
      width: 7rem;
    }
  }
`;

const Navigators = styled(motion.ul)`
  display: flex;
  width: 100%;

  @media (max-width: 1180px) {
    display: none;
  }
`;

const ButtonContainer = styled(motion.div)`
  display: flex;
  margin-right: 0.5rem;

  @media (max-width: 1180px) {
    display: none;
  }
`;

const LoginButton = styled(secondaryBtn)`
  padding: 0.3rem 1.5rem;
  box-shadow: none;

  @media (max-width: 1180px) {
    margin: 0rem;
    text-align: center;
    background: #19456b;
    color: white;
    margin: 0.5rem 0rem;
    border: none;
  }
`;

const SignUpBtn = styled(primaryBtn)`
  padding: 0.3rem 1.5rem;
  color: #19456b;
  margin-left: 1rem;
  box-shadow: none;
  border: 1.5px solid white;

  @media (max-width: 1180px) {
    text-align: center;
    background: white;
    margin: 0rem;
    margin: 0.5rem 0rem;
    border: 0.5px solid white;
  }
`;

const ExtraNav = styled(BasicDiv)`
  justify-content: flex-end;
  margin-right: 1rem;

  @media (max-width: 1180px) {
    display: flex;
    justify-content: center;
    padding: 0rem;
    margin: 0rem;
    align-items: center;
  }

  div {
    margin-left: 1rem;
    cursor: pointer;

    @media (max-width: 1180px) {
      display: none;
    }
  }

  .search-input {
    border: none;
    background: #ffffff;
    padding: 0rem 0.5rem;
    width: 100%;
    border-radius: 3rem;
  }

  .search-div {
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0rem;
    background: #ffffff;
    width: 15rem;
    padding: 0.3rem 0.5rem;
    border-radius: 3rem;
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.1);
    margin-left: 1.5rem;

    @media (max-width: 1180px) {
      margin: 0rem;
      width: 20rem;
      box-shadow: none;
    }

    img {
      width: 0.9rem;
      padding: 0.1rem 0rem;
      padding-left: 0.1rem;
    }

    input:focus {
      outline: none;
    }
  }

  .province-select,
  .lang-btn,
  .abm {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none; /* Remove default arrow */
    border: none;
    padding: 0rem 0.5rem;
    background: none;
    cursor: pointer;
    border-radius: 3rem;
    /* border: solid 2px #19456b; */

    @media (max-width: 1180px) {
      display: none;
      width: 0px;
    }
  }

  .province-select:hover,
  .lang-btn:hover,
  .abm:hover {
    background: #e4e0e0;
    border-radius: 0.2rem;
  }
`;
